var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Col',{attrs:{"span":_vm.config.span || 8}},[(_vm.isShow)?_c('FormItem',{style:({
      marginBottom: _vm.config.props.bottom ? `${_vm.config.props.bottom}px` : '10px'
    }),attrs:{"label":`${_vm.config.label}`,"prop":_vm.config.key,"rules":_vm.config.rule}},[_c('i-switch',{attrs:{"disabled":_vm.disabled},model:{value:(_vm.data[_vm.config.key]),callback:function ($$v) {_vm.$set(_vm.data, _vm.config.key, $$v)},expression:"data[config.key]"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }